
import { defineComponent, useContext, useMeta } from '@nuxtjs/composition-api';
import WhereToBuyMainSection from '~/domains/where-to-buy/components/WhereToBuyMainSection';
import useAlternateLinks from '~/composables/useAlternateLinks';

export default defineComponent({
  components: { WhereToBuyMainSection },
  head: {},
  setup() {
    const { i18n } = useContext();
    const { alternateLinks } = useAlternateLinks();

    useMeta(() => ({
      title: `${i18n.t('where_to_buy')}`,
      meta: [
        {
          property: 'og:title',
          content: `${i18n.t('where_to_buy')}`,
        },
      ],
      link: alternateLinks.value,
    }));
  },
});
